import {Model} from './model';

export class InvoiceAttachmentType implements Model {

  description: string;
  invoiceAttachmentTypeId: number;

  static copy(oldObj: InvoiceAttachmentType): InvoiceAttachmentType {
    const newObj = new InvoiceAttachmentType();
    newObj.description = oldObj.description;
    newObj.invoiceAttachmentTypeId = oldObj.invoiceAttachmentTypeId;
    return newObj;
  }

  getPrimaryKey() {
    return this.invoiceAttachmentTypeId;
  }

  isNew(): boolean {
    return isNaN(this.invoiceAttachmentTypeId);
  }

  clone(): InvoiceAttachmentType {
    return InvoiceAttachmentType.copy(this);
  }
}
